export class AppSettings {
    static readonly Url = "https://www.bep-id.com/"
}